import request from '@/router/axios';

export const getList = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/teammember/cFactoryList',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

export const transferDormitory = (params, headers) => request({
  url: '/api/mcc-worker/info/workerCR',
  method: 'post',
  headers,
  data: params,
})

// 转宿舍流程全部导出接口
export const downLoadAllDormitory = params => request({
  url: '/api/mcc-worker/processfield/DaoChuCR',
  method: 'get',
  responseType: 'blob',
  params: {
    formId: '26',
  },
})

// 转宿舍流程个人导出接口
export const downLoadDormitory = params => request({
  url: '/api/mcc-worker/processfield/DaoChuCRPerson',
  method: 'get',
  responseType: 'blob',
  params: {
    formId: '26',
  },
})

export default {
  getList,
}
